import { IComponentOptions } from "angular";
import { MachineEditFormComponentController } from "./controller";

export const vsComponentName = "machineEditForm";

export const MachineConfigurationEditFormComponentOptions: IComponentOptions = {
  controller: MachineEditFormComponentController,
  controllerAs: "machineEditFormController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    model: "<",
    machineFieldsEditable: "<",
    onSubmit: "<",
    onCancel: "<",
    formTitle: "<",
    isConversion : "<"
  },
};
